export default [
  {
    educationTitle: "Master of Biomedical Engineering",
    educationDescription: [
      "Research and prototyping biomedical technologies",
      "Apply engineering analysis and techniques to problems in medicine and life sciences",
      "Develop systems to maintain and enhance life",
    ],
  },
  {
    educationTitle: "Bachelor of Mechatronic Engineering",
    educationDescription: [
      "Development of autonomous systems",
      "Thorough knowledge of industrial automation",
      "Design and development of web technologies",
      "Fundamental knowledge of computing systems",
    ],
  },
];
